import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 20000 });

// Strip empty/null fields so optional EmailStr / Optional[str] backend validators don't reject blank inputs.
const clean = (obj) =>
  Object.fromEntries(
    Object.entries(obj || {}).filter(([, v]) => v !== "" && v !== null && v !== undefined)
  );

export const submitLead = (payload) => api.post("/leads", clean(payload)).then((r) => r.data);
export const submitContact = (payload) => api.post("/contact", clean(payload)).then((r) => r.data);
export const runAssessment = (payload) => api.post("/needs-assessment", clean(payload)).then((r) => r.data);
export const adminLogin = (password) => api.post("/admin/login", { password }).then((r) => r.data);
export const fetchArticles = (params = {}) => api.get("/articles", { params }).then((r) => r.data);
export const fetchArticle = (slug) => api.get(`/articles/${slug}`).then((r) => r.data);

export const adminLeads = (token) =>
  api.get("/admin/leads", { headers: { "X-Admin-Token": token } }).then((r) => r.data);

export const adminStats = (token) =>
  api.get("/admin/stats", { headers: { "X-Admin-Token": token } }).then((r) => r.data);
